module.exports = __webpack_public_path__ + "static/media/Cartoon_map.89462808.jpg";